import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { ToastComponent } from '../../shared/toast/toast.component';
import { AuthService } from '../../services/auth.service';
import { RecordService } from '../../services/record.service';
import { User } from '../../shared/models/user.model';
import { generateListItem, setClassInvalid } from '../../shared/functions';
import { activities, dateRegexp, ee, feedbacks, formats, statuses, urlRegexp } from '../../shared/constants';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-add-record-form',
  templateUrl: './add-record-form.component.html',
  standalone: false
})
export class AddRecordFormComponent implements OnInit, OnDestroy {
  private auth = inject(AuthService);
  private recordService = inject(RecordService);
  private formBuilder = inject(UntypedFormBuilder);
  toast = inject(ToastComponent);


  @Input() team: User[] = [];

  addRecordForm = this.createRecordForm();
  canAssignRecord = false;
  formats = formats;
  statuses = statuses;
  activities = activities;
  dateRegexp = dateRegexp;
  urlRegexp = urlRegexp;
  feedbacks = feedbacks;
  setClassInvalid = setClassInvalid;

  ngOnInit(): void {
    ee.on('searchInput', (obj: any) => this.addRecordForm.patchValue(obj));
    this.canAssignRecord = this.auth.currentUser.permissions?.includes('assignRecord');
  }

  ngOnDestroy(): void {
    ee.off('searchInput', () => {});
  }

  createRecordForm(): UntypedFormGroup {
    return this.formBuilder.group({
      title: ['', Validators.required],
      activity: ['', Validators.required],
      status: ['', Validators.required],
      date: ['', Validators.required],
      _user: [this.auth.currentUser._id, Validators.required],
      _users: [[]],
      _politicians: [[]],
      _clients: [[], Validators.required],
      _organizations: [[]],
      clients: [''],
      driveurl: ['', Validators.pattern(/^https?:\/\/.*/)],
      externalurl: ['', Validators.pattern(/^https?:\/\/.*/)],
      externalurl2: ['', Validators.pattern(/^https?:\/\/.*/)],
      notes: ['', Validators.required],
      format: [''],
      moderator: [''],
      followupnotes: [''],
      feedback: [''],
      followup: ['']
    });
  }

  addListItem(type: string): void {
    const notes = this.addRecordForm.get('notes').value;
    const listItem = generateListItem(type);
    this.addRecordForm.patchValue({ notes: `${notes}${listItem}` });
  }

  isFormInvalid(): boolean {
    return !this.addRecordForm.valid ||
      (this.addRecordForm.get('followup').value === 'yes' && !this.addRecordForm.get('followupnotes').value) ||
      (this.addRecordForm.get('activity').value === 'UTOPIA Studios - URANIA' && (!this.addRecordForm.get('format').value ||
        !this.addRecordForm.get('moderator').value));
  }

  setClassInvalidAndCanAssignRecord(form: UntypedFormGroup, prop: string) {
    const setClassInvalidObj = setClassInvalid(form, prop);
    if (!this.canAssignRecord) {
      setClassInvalidObj.disabled = true;
      document.getElementById('you-or-assignee-select').setAttribute('tabindex', '-1');
    }
    return setClassInvalidObj;
  }

  addRecord(): void {
    this.recordService.add(this.addRecordForm.value)
      .pipe(finalize(() => {
        ee.emit('getRecords');
        ee.emit('recordAdded', true);
      }))
      .subscribe({
        next: res => this.toast.setMessage('Record added successfully!', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

}
